import React, { useRef, useCallback, useState, useEffect } from 'react';
import LoadingUI from '../../components/ui/LoadingUI';
import { useStyles } from './Style'
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import pt from 'date-fns/locale/pt';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DeliveryWindowDate } from '../../interfaces/Mvm';
import MvmApi from '../../services/MvmApi';
import Grid from '@material-ui/core/Grid';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import { useSnackbar } from 'notistack';

type Props = {
    mvmId: number,
    deliveryWindowDate: Date,
    clickHandlerCalbkack?: () => void,
    clickHandlerClose?: () => void
}

const WindowFiapeForm: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation("WindowFiape");
    const { enqueueSnackbar } = useSnackbar();
    const [dateSelected, setDateSelected] = React.useState<Date | null>(new Date());
    const [timeSelected, setTimeSelected] = React.useState<Date | null>(new Date());
    const timePickerField = useRef<HTMLInputElement>(null);


    useEffect(() => {
        let date: Date = props.deliveryWindowDate;
        if (date === null) date = new Date();
        
        setDateSelected(date);
        setTimeSelected(date);

        setLoading(false);

        //useEffect nao esta permitindo setar o foco no campo assim que o <Dialog> abre com esta view. Portanto, setTimeout pra forçar o foco apos renderizar tudo:
        window.setTimeout(setInitialFocus, 500);

    }, [props]);

    const setInitialFocus = () => {
        timePickerField.current?.focus();
        timePickerField.current?.select();
      };

    const saveData = () => {
        let date = new Date(dateSelected ?? "");
        let time = new Date(timeSelected ?? "");
        
        let ano = date.getUTCFullYear();
        let mesN = date.getUTCMonth() + 1;
        let diaN = date.getUTCDate();
        let horaN = time.getHours() === undefined ? 0 : time.getHours();
        let minutoN = time.getMinutes() === undefined ? 0 : time.getMinutes();
        
        let mes = mesN < 10 ? `0${mesN}` : String(mesN);
        let dia = diaN < 10 ? `0${diaN}` : String(diaN);
        let hora = horaN < 10 ? `0${horaN}` : String(horaN);
        let minuto = minutoN < 10 ? `0${minutoN}` : String(minutoN);


        let dateTimeSelected = `${ano}-${mes}-${dia}T${hora}:${minuto}:00`;

        setOpenBackdrop(true);
        let deliveryWindowDate: DeliveryWindowDate = {
            id: props.mvmId,
            deliveryWindowDate: dateTimeSelected
        }

        handleSubmit(deliveryWindowDate);
    };

    const handleSubmit = useCallback(
        async (data: DeliveryWindowDate) => {
            MvmApi.UpdateDeliveryWindowDate(data)
                .then(result => {
                    enqueueSnackbar(t("returnSubmitFormSuccess"), { variant: 'success' });
                    if (props && props.clickHandlerCalbkack)
                        props.clickHandlerCalbkack()
                }).finally(() => {
                    setOpenBackdrop(false);
                });
        },
        [props, enqueueSnackbar, t]
    );


    return (
        loading ?
            <LoadingUI />
            :
            <>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container spacing={2}>
                    <Grid item xs={9}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pt}>
                            <StaticDatePicker
                                displayStaticWrapperAs="desktop"
                                openTo="day"
                                value={dateSelected}
                                onChange={setDateSelected}
                                renderInput={(params) => <TextField {...params} />}
                            />

                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={3}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pt}>
                            <TimePicker
                                    inputRef={timePickerField}
                                    value={timeSelected}
                                    label={t('time')}
                                    onChange={setTimeSelected}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} className={classes.footForm}>
                        <Button variant="contained" className={classes.rootCancelButton} onClick={() => props && props.clickHandlerClose ? props.clickHandlerClose() : null}>
                            {t("cancel")}
                        </Button>

                        <Button onClick={saveData} variant="contained" color="primary" className={classes.rootButton}>
                            {t("confirm")}
                        </Button>
                    </Grid>
                </Grid>
            </>
    )
}
export default WindowFiapeForm;